import { DECIMAL } from './DECIMAL.ts'
import { INTEGER } from './INTEGER.ts'

export const INTEGER_DECIMAL: string = `${INTEGER} or ${DECIMAL}`
